import { render, staticRenderFns } from "./newConversation.vue?vue&type=template&id=5915d456"
import script from "./newConversation.vue?vue&type=script&lang=js"
export * from "./newConversation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NewAccountSelector: require('/home/runner/_work/plannr-nuxt/plannr-nuxt/components/NewAccountSelector.vue').default,InfoBoxClientNoLogins: require('/home/runner/_work/plannr-nuxt/plannr-nuxt/components/InfoBoxClientNoLogins.vue').default,ErrorBlock: require('/home/runner/_work/plannr-nuxt/plannr-nuxt/components/ErrorBlock.vue').default})
